module.exports = __webpack_public_path__ + "static/media/zalo.efa74b01.svg";